import React from 'react';
import './index.less';

export const tablePageSecondHeaderSkeletonShape = (
    <div className="tablePageSecondHeaderSkeletonShape">
        <div className="rect-left" />
        <div className="rect-right" />
    </div>
);
